module Meevo.Components.Compensation {
    angular.module("meevo.components.compensation", []);
}